module.exports = __webpack_public_path__ + "img/img_locker_success.d81e9b1d.png";